import React, { useState } from 'react';
import { FileUploadModalBody, Modal } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Form } from 'react-bootstrap';
const ClaimSelectModal = _ref => {
  let {
    show,
    onHide,
    claims,
    title,
    getSelectedClaimUrl,
    targetPage
  } = _ref;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [selectedClaim, setSelectedClaim] = useState(null);
  const goToUrl = () => {
    const url = getSelectedClaimUrl(targetPage, selectedClaim);
    history.push(url);
  };
  const renderBody = /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "claim_select",
    onChange: e => setSelectedClaim(e.target.value),
    value: selectedClaim,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), claims.map(c => {
    return /*#__PURE__*/React.createElement("option", {
      value: c.id
    }, c.to_date.slice(-4));
  }));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: title,
    show: show,
    renderBody: () => renderBody,
    onHide: onHide,
    onSubmit: () => goToUrl(),
    submitText: t('go_to_claim')
  });
};
export default ClaimSelectModal;